import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import SingleSelectCards from './SingleSelectCards';

const PREFERENCE_OPTIONS = [
  { value: 'diy', label: 'Zelf installeren', hint: 'Ik regel het zelf met de uitleg' },
  { value: 'professional', label: 'Installateur laten installeren', hint: 'Liever een vakman' },
  { value: 'advice_first', label: 'Eerst advies', hint: 'Eerst even meedenken' },
];

export default function StarterKitDetailsStep({ data, onUpdate, errors }) {
  const fld = (id, label, type = 'text', required = false, autoComplete) => (
    <div>
      <Label htmlFor={id} className="mb-1.5 block">{label}{required && ' *'}</Label>
      <Input
        id={id}
        type={type}
        autoComplete={autoComplete}
        value={data[id] || ''}
        onChange={(e) => onUpdate({ [id]: e.target.value })}
        data-testid={`ec-sk-${id}`}
        className={errors?.[id] ? 'border-destructive' : ''}
      />
      {errors?.[id] && <p className="text-xs text-destructive mt-1">{errors[id]}</p>}
    </div>
  );

  return (
    <div className="space-y-6" data-testid="ec-sk-details">
      <div>
        <h2 className="text-2xl font-medium text-primary mb-1" style={{ fontFamily: 'Outfit' }}>
          Vraag mijn startpakket aan
        </h2>
        <p className="text-sm text-muted-foreground">
          We sturen u de logische vervolgstap op maat van uw situatie en compatibiliteitskeuze.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {fld('name', 'Naam', 'text', true, 'name')}
        {fld('email', 'E-mail', 'email', true, 'email')}
        {fld('phone', 'Telefoon', 'tel', true, 'tel')}
        {fld('postcode', 'Postcode', 'text', true, 'postal-code')}
      </div>

      {fld('street', 'Straat + huisnummer', 'text', true, 'street-address')}
      {fld('city', 'Stad', 'text', true, 'address-level2')}

      <SingleSelectCards
        label="Welke route past het beste?"
        value={data.preference}
        options={PREFERENCE_OPTIONS}
        onChange={(v) => onUpdate({ preference: v })}
        testIdPrefix="ec-sk-pref"
        error={errors?.preference}
        columns={3}
      />

      <div>
        <Label htmlFor="ec-sk-message" className="mb-1.5 block">Korte opmerking (optioneel)</Label>
        <Textarea
          id="ec-sk-message"
          value={data.message || ''}
          onChange={(e) => onUpdate({ message: e.target.value })}
          rows={3}
          placeholder="Optioneel: aandachtspunten of vragen"
          data-testid="ec-sk-message"
        />
      </div>

      <div className="text-xs text-muted-foreground">
        Door te bevestigen ontvangt u uw startpakket-aanvraag bevestigd op {data.email || 'uw e-mail'}.
        We bellen of mailen u binnen 2 werkdagen met de logische vervolgstap.
      </div>
    </div>
  );
}
